/**
 * Global Error Boundary — App Router
 *
 * Catches runtime errors at the root level.
 * Must be a Client Component.
 */
'use client';

import {useEffect} from 'react';

export default function GlobalError({error, reset}: {error: Error & {digest?: string}; reset: () => void}) {
    useEffect(() => {
        console.error('[GlobalError]', error);
    }, [error]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-4">
            <h2 className="text-xl font-semibold text-gray-800">Đã xảy ra lỗi</h2>
            <p className="text-sm text-gray-500">Vui lòng thử lại sau hoặc liên hệ bộ phận hỗ trợ.</p>
            <button
                onClick={reset}
                className="rounded-lg bg-[var(--color-primary-100)] px-6 py-2 text-white hover:opacity-90">
                Thử lại
            </button>
        </div>
    );
}
